module.exports = __webpack_public_path__ + "static/media/20201219_131027_805_IMG_3434.9ccde11d.jpg";